import { KeyboardArrowDown } from "@mui/icons-material";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import Condition from "../../../components/Conditional/Condition";
import ChangeDineInTakeawayModal from "../CartModals/ChangeDineInTakeawayModal";
import { useDineInTakeawayButton } from "./useDineInTakeawayButton";

const DineInTakeawayButton = (): ReactElement => {
	const { t } = useTranslation();

	const { takeaway, showOption, hideOption, isOpen } = useDineInTakeawayButton();

	return (
		<>
			<button className="DineInTakeawayButton" onClick={showOption}>
				<Condition check={!takeaway}>{t("DiningOptionsPage.dinein")}</Condition>
				<Condition check={takeaway}>{t("DiningOptionsPage.takeaway")}</Condition>
				<KeyboardArrowDown />
			</button>
			<ChangeDineInTakeawayModal isOpen={isOpen} closeFn={hideOption} />
		</>
	);
};

export default DineInTakeawayButton;
